var standardDna = [
    {
     chr: 1,
     size: 247249719
    },
    {
     chr: 2,
     size: 242951149
    },
    {
     chr: 3,
     size: 199501827
    },
    {
     chr: 4,
     size:191273063
    },
    {
     chr: 5,
     size: 180857866
    },
    {
     chr: 6,
     size: 170899992
    },
    {
     chr: 7,
     size: 158821424
    },
    {
     chr: 8,
     size: 146274826
    },
    {
     chr: 9,
     size: 140273252
    },
    {
     chr: 10,
     size: 135374737
    },
    {
     chr: 11,
     size: 134452384
    },
    {
     chr: 12,
     size: 132349534
    },
    {
     chr: 13,
     size: 114142980
    },
    {
     chr: 14,
     size: 106368585
    },
    {
     chr: 15,
     size: 100338915
    },
    {
     chr: 16,
     size: 88827254
    },
    {
     chr: 17,
     size: 78774742
    },
    {
     chr: 18,
     size: 76117153
    },
    {
     chr: 19,
     size: 63811651
    },
    {
     chr: 20,
     size: 62435964
    },
    {
     chr: 21,
     size: 46944323
    },
    {
     chr: 22,
     size: 49691432
    },
    {
     chr: 23,
     size: 154913754
    }
    ];

export default standardDna;